import { Button } from 'components/Button/Button';
import CompleteModal from 'components/CompleteModal/CompleteModal';
import Modal from 'components/Modal/Modal';
import appHelpers, { getMarketingUrl } from 'utils/app-urls';

const cdnURL = appHelpers.getCDNUrl();
const errorImg = `${cdnURL}assets/components/modal/exclamation.svg`;

export const CryptoModal = ({ messages, isOpen, hide }: any) => {
  const cryptoModalTitle = <div>{messages.modalCryptoHeader}</div>;

  const cryptoModalContent = (
    <div className="flex flex-col items-center gap-6">
      {messages.modalCryptoContent.map((content: string) => (
        <p className="text-start">{content}</p>
      ))}
    </div>
  );

  return (
    <Modal
      hideModal={hide}
      show={isOpen}
      content={cryptoModalContent}
      hasTitle
      title={cryptoModalTitle}
      closeModal={hide}
      height="auto"
    />
  );
};

export const DisclaimerModal = ({ messages, isOpen, hide }: any) => {
  const disclaimerModalTitle = <div>{messages.modalDisclaimerHeader}</div>;

  const disclaimerModalContent = (
    <div className="flex flex-col items-center gap-6">
      {messages.modalDisclaimerContent.map((content: string) => (
        <p className="text-start">{content}</p>
      ))}
      <p className="text-start">
        {messages.graphSubText1}{' '}
        <a
          target="_blank"
          rel="noreferrer noopener"
          className="underline"
          href={`${getMarketingUrl()}/fees`}>
          {messages.graphSubText2}
        </a>{' '}
        {messages.graphSubText3}{' '}
        <a
          target="_blank"
          rel="noreferrer noopener"
          className="underline"
          href={`${getMarketingUrl()}/legal/risk-disclosure`}>
          {messages.graphSubText4}
        </a>{' '}
        {messages.graphSubText5}{' '}
        <a
          target="_blank"
          rel="noreferrer noopener"
          className="underline"
          href={`${getMarketingUrl()}/legal/risk-disclosure`}>
          {messages.graphSubText6}
        </a>
        .
      </p>
    </div>
  );

  return (
    <Modal
      hideModal={hide}
      show={isOpen}
      title={disclaimerModalTitle}
      content={disclaimerModalContent}
      hasTitle
      closeModal={hide}
      height="auto"
    />
  );
};

export const ReturnsModal = ({ messages, isOpen, hide }: any) => {
  const returnsModalTitle = (
    <h3 className="mt-1 mr-0 -mb-3 ml-1">{messages.modalReturnsHeader}</h3>
  );

  const returnsModalContent = (
    <div dangerouslySetInnerHTML={{ __html: messages.modalReturnsContent }} />
  );

  return (
    <Modal
      hideModal={hide}
      show={isOpen}
      content={returnsModalContent}
      hasTitle
      title={returnsModalTitle}
      closeModal={hide}
    />
  );
};

export const VerifyModal = ({
  messages,
  isOpen,
  hide,
  verificationPendingMessages,
}: any) => {
  const busyVerifyingModal = (
    <div>
      <CompleteModal
        heading={verificationPendingMessages.verifyingAccount.heading}
        subheading={verificationPendingMessages.verifyingAccount.subheading}
        continueButton={messages.closeModal}
        onComplete={hide}
      />
    </div>
  );
  return (
    <Modal
      hideModal={hide}
      content={busyVerifyingModal}
      closeModal={hide}
      show={isOpen}
    />
  );
};

export const PendingDepositModal = ({
  isOpen,
  messages,
  hide,
  navigateToProfile,
  cancelCryptoDeposit,
}: any) => {
  const pendingCryptoTitle = (
    <div className="flex flex-col items-center">
      <img src={errorImg} alt={messages.modalAlt} />
      <div className="pt-7">{messages.modalHeadingCrypto}</div>
    </div>
  );
  const pendingCryptoContent = (
    <div className="text-center pb-5 text-body-text font-normal">
      {messages.modalContentCrypto}
    </div>
  );
  const pendingCryptoFooter = (
    <div className="w-full flex flex-col justify-center items-center pb-4">
      <Button main onClick={() => navigateToProfile()}>
        {messages.modalProfileCrypto}
      </Button>

      <Button
        className="mt-4"
        main
        secondary
        onClick={() => cancelCryptoDeposit()}>
        {messages.modalCancelCrypto}
      </Button>
    </div>
  );
  return (
    <Modal
      hideModal={isOpen}
      show={isOpen}
      content={pendingCryptoContent}
      hasTitle
      title={pendingCryptoTitle}
      hasFooter
      footer={pendingCryptoFooter}
      closeModal={hide}
    />
  );
};

export default {
  CryptoModal,
  ReturnsModal,
  VerifyModal,
  DisclaimerModal,
  PendingDepositModal,
};
